"use client";
import { createTheme } from "@mui/material";
import colors from "./color";

declare module '@mui/material/styles' {
    interface BreakpointOverrides {
        xs2: true;
        sm2: true;
        md2: true;
        lg2: true;
    }
}

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            xs2: 320,
            sm: 600,
            sm2: 768,
            md: 900,
            md2: 1024,
            lg: 1200,
            lg2: 1416,
            xl: 1536,
        }
    },
    typography: {
        fontFamily: ['font', "sans-serif"].join(","),
        allVariants: {
            fontFeatureSettings: '"ss02"'
        }
    },
    palette: {
        primary: {
            main: "#BB202E",
        },
        secondary: {
            main: '#242424',
        }
    },
    components: {
        // MuiOutlinedInput: {
        //     styleOverrides: {
        //         root: {
        //             "&:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline": {
        //                 borderColor: "red",
        //             },
        //         },
        //     },
        // },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: colors.primary,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: colors.primary,
                    },
                    "&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fff",
                    },
                    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#fff",
                    },
                    "&.MuiInputBase-colorPrimary": {
                        background: "#0000000A",
                        "&.Mui-focused": {
                            background: "#fff",
                        },
                    },
                },
                input: {
                    fontSize: 15,
                },
                // input: {
                //     border: "none",
                //     backgroundColor: "#0000000A",
                //     borderRadius: 8,
                //     ":focus": {
                //         background: "none",
                //     },
                // },
                notchedOutline: {
                    borderColor: "#fff",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    '& .lucide': {
                        color: 'inherit !important',
                    }
                }
            }
        }
    },
    shape: {
        borderRadius: 8,
    },
});

export default theme;
